import React from 'react';
import { Mail, Instagram, Facebook } from 'lucide-react';
export function Footer() {
  return <footer className="bg-dark border-t border-dark-border py-12 px-4" data-id="element-117">
      <div className="max-w-6xl mx-auto flex flex-col items-center text-center" data-id="element-118">
        <div className="flex items-center gap-3 mb-6" data-id="element-119">
          <span className="text-3xl" data-id="element-120">🧠</span>
          <h2 className="text-xl md:text-2xl font-heading font-bold text-white tracking-wider" data-id="element-121">
            ACADEMIA HOLÍSTICA ARGENTINA
          </h2>
        </div>

        <p className="text-gray-400 max-w-2xl mb-4" data-id="element-122">
          El sistema de transformación personal con PNL aplicada al contexto
          argentino.
        </p>
        <p className="text-gray-500 max-w-2xl mb-12 italic" data-id="element-123">
          Porque tu soberanía personal no debería postergarse por falta de un
          sistema a la altura de lo que sos capaz.
        </p>

        <div className="flex flex-col md:flex-row gap-6 md:gap-12 mb-12 text-gray-400" data-id="element-124">
          <a href="#" className="flex items-center gap-2 hover:text-gold transition-colors" data-id="element-125">
            <Mail className="w-5 h-5" data-id="element-126" />
            <span data-id="element-127">academiaholisticaargentina@gmail.com</span>
          </a>
          <a href="#" className="flex items-center gap-2 hover:text-gold transition-colors" data-id="element-128">
            <Instagram className="w-5 h-5" data-id="element-129" />
            <span data-id="element-130">@academiaholisticaargentina</span>
          </a>
          <a href="#" className="flex items-center gap-2 hover:text-gold transition-colors" data-id="element-131">
            <Facebook className="w-5 h-5" data-id="element-132" />
            <span data-id="element-133">Academia Holística Argentina</span>
          </a>
        </div>

        <div className="w-full border-t border-dark-border/50 pt-8 flex flex-col items-center gap-4" data-id="element-134">
          <p className="text-sm text-gray-600" data-id="element-135">
            © Academia Holística Argentina 2026 Todos los derechos reservados.
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
          <p className="text-sm text-gold-dark font-heading italic" data-id="element-136">
            🧠 "El único contexto que realmente podés cambiar es el que tenés
            adentro."
          </p>
        </div>
      </div>
    </footer>;
}